(function() {
    'use strict';
    angular.module('irricrops')
    .directive('analisisChart', [function() {
      var directive = {
        restrict         : 'E',
        templateUrl      : 'shared/analisisChart/analisis.html',
        controller       : "analisisChartCtrl",
        controllerAs     : 'sc',
        bindToController : true,
        scope : {
          config : "=",
        }
      };
      return directive;
    }])

  .controller("analisisChartCtrl",
  ["$scope","MultiChart", "Config", "$state", "estadisticaFac","$stateParams","$filter","urls",
  "$mdDialog","CuartelFac","$timeout","cuartelDialog", "$rootScope","$q","temporadaFac", "$http", "global",
  function($scope, MultiChart, Config, $state, estadisticaFac, $stateParams,$filter,urls,
    $mdDialog, CuartelFac, $timeout, cuartelDialog, $rootScope, $q, temporadaFac, $http, global){

      var vm                   = this;
      var dataHttp             = vm.config.http;
      vm.chartConfig           = "";
      vm.allCharts             = true; //loading
      vm.estados               = [];
      vm.meses                 = [];
      vm.inicio                = moment("2017-01-01").toDate();
      vm.termino               = moment("2017-03-31").toDate();
      vm.sectoresList          = [];
      vm.charts                = {};
      vm.sectoresSeleccionados = [];
      vm.showBackdrop          = false;
      vm.hideBackDrop          = null; //funcion dinamica, se llena al hacer click en el label del grafico
      //vm.listMode            = true; //XXX asimir que sera siempre TRUE
      vm.temporadas            = [];
      vm.temporadaSelected     = null;
      vm.listaSectores         = [];
      vm.lista                 = {};
      vm.equipoActivo          = null;
      vm.tipoGraficoSelected   = 'analisis';
      vm.conResumen            = true;
      vm.conMiniResumen        = false;
      vm.conHistorico          = true;
      vm.mesSelected           = null;
      vm.estadoSelected        = null;
      vm.chartResumenMax       = {};
      vm.chartResumenMini      = {};
      vm.lapsos                = {};
      vm.lapsoSelected         = null;
      vm.grupos                = null;
      vm.gruposArray           = null;
      vm.grupoSelected         = null;

      vm.COMP_DATE = {
        label: "A la fecha"
      };

      vm.COMP_TEMPORADA = {
        label: "Temporada"
      };

      vm.comparisonTypeArray = [
          vm.COMP_TEMPORADA,
          vm.COMP_DATE
      ];

      vm.comparisonTypeSelected = vm.COMP_TEMPORADA;

      vm.mobileChart           = false;
      if(global.responsiveIs("xs")){
        vm.mobileChart = true;
        vm.conResumen = false;
      }

      var $optionToolbar       = $(".options-toolbar");
      var $miniResumen         = $(".mini-resumen");
      var $content             = $("#content");
      //var ocultando            = false;
      var namesHistoricos      = [];

    vm.resumen = {
      etAcum     : 0,
      reposicion : 0,
      volumen    : 0,
      horas      : 0
    };


      vm.periodos = [
        {
          id: 1,
          nombre: "Temporada",
          lapso:'temporada',
          label:'temporada',
          agrupado : false
        },
        {
          id: 2,
          nombre: "Meses",
          lapso:'meses',
          label:'meses',
          agrupado :true
        },
        {
          id: 3,
          nombre: "Entre Fechas",
          lapso:'temporada', //logica igual al de temporada
          label:'fechas',
          agrupado : false
        },
        /*
        {
          id: 4,
          nombre: "Estado Fenologico",
          lapso:'estados',
          label:'estados',
          agrupado :true
        }
        */
      ];
      vm.periodoSelected = vm.periodos[0];


      vm.agrupacion = [
        /*{
          id: 1,
          label: "vinedos",
          nombre : "Viñedos"
        },*/
        {
          id: 1,
          label: "equipos",
          nombre : "Equipos",
        },
        {
          id: 2,
          label: "calidades",
          nombre : "Calidades",
        },
        {
          id: 3,
          label: "variedades",
          nombre : "Variedades",
        }
      ];
      vm.agrupacionSelected = vm.agrupacion[2]; //equipo




    var paramsResumen = [
          {
            nameParam : "volumenRealHA",
            title : "Volumen"
          },
        /*
          {
            nameParam: "riegoIdeal",
            title : "Riego Teórico"
          },
          */
          {
            nameParam: "porcentajeReal",
            title: "Porcentaje Real",
            defaultData: 0
          },
          /*
          {
            nameParam: "porcentajeIdeal",
            title : "Porcentaje Teórico"
          },
          {
            nameParam: "produccionReal",
            title: "Producción Real"
          },
          {
            nameParam: "produccionEsperada",
            title: "Producción Esperada"
          },
      */
          {
            nameParam: "etAcum",
            title: "Et Acumulada"
          },
        ];
    vm.paramsResumen = paramsResumen;




    /*
    $content.scroll(function(ev) {
      //$optionToolbar.css('top', $content.scrollTop());
      //$miniResumen.css('top', $content.scrollTop());
      if ($content.scrollTop() > 50 && !ocultando) {
        $miniResumen.addClass('show');
      }else{
        $miniResumen.removeClass('show');
      }
      if ($content.scrollTop() === 0) {
        ocultando = false;
      }
    });


    vm.showResumenMax = function() {
      $content.animate({ scrollTop: 0 }, "fast");
      $miniResumen.removeClass('show');
      ocultando = true;
    };

    */






//TABLES ------------------------------------------------------

    vm.tableMouseOverTemporada = function(item){
      var c = vm.chartResumenMax.config.getHighcharts();
      var p = [];
      //var event = c.pointer.normalize(e.originalEvent); // Find coordinates within the chart

      angular.forEach(c.series, function(serie){
        angular.forEach(serie.points, function(point){
          if (point !== undefined && point.category == item.name) {
            p.push(point);
            point.onMouseOver(); // Show the hover marker
          }
        });
      });
      c.xAxis[0].drawCrosshair(null, p[0]); // Show the crosshair
      c.tooltip.refresh(p, null); // Show the tooltip
    }

    vm.tableMouseLeaveTemporada = function(){
      var c = vm.chartResumenMax.config.getHighcharts();
      angular.forEach(c.series, function(serie){
        angular.forEach(serie.points, function(point){
            point.onMouseOut();
        });
      });
      c.xAxis[0].hideCrosshair();
      c.tooltip.hide();
    }







    vm.tableReflowChart = function(item){
      var c = vm.chartResumenMax.config.getHighcharts();
      var p = [];
      //var event = c.pointer.normalize(e.originalEvent); // Find coordinates within the chart

        angular.forEach(c.series, function(serie){
          if (serie.options.name.indexOf(item.name) > -1) {
            if(item.checked){
              //serie.show();
              serie.update({
                visible:true,
                showInLegend: true
              }, false);
              //vm.chartResumenMax.mchart.setVar("visible", [serie.options.name],true);
              //vm.chartResumenMax.mchart.setVar("showInLegend", [serie.options.name],true);
            }else{
              serie.update({
                visible:false,
                showInLegend: false
              }, false);
              //vm.chartResumenMax.mchart.setVar("visible", [serie.options.name],false);
              //vm.chartResumenMax.mchart.setVar("showInLegend", [serie.options.name],false );
            }
          }
        });
      $timeout(function() {
        //mejor que refow en este caso
        c.redraw();
        c.setSize(undefined, undefined, true);
      }, 100);
    }



    vm.tableMouseOver = function (item) {
      switch (vm.periodoSelected.lapso) {
        case 'temporada':
          vm.tableMouseOverTemporada(item);
            break;
        case 'meses':
        case 'estados':
          //vm.tableMouseOverLapso(item);
            break;
      }
    };

    vm.tableMouseLeave = function () {
      switch (vm.periodoSelected.lapso) {
        case 'temporada':
          vm.tableMouseLeaveTemporada();
            break;
        case 'meses':
        case 'estados':
            break;
      }
    };


// END TABLES --------------------------------------------------














      vm.getMChart = function(p){ //title, item, periodo,mc) {
        console.log(p.periodo.periodo+" "+p.item.nombre);
        var mchart;
        var mchartRep;

        if(p.mchartObj === null || p.mchartObj === undefined){
          mchart = new MultiChart(p.title);
          mchartRep = new MultiChart(p.titleRep);
        }else{
          mchart = p.mchartObj.mchart;
          mchartRep = p.mchartObj.mchartRep;
        }
        var chartConfig = mchart.getConfig();
        var chartConfigRep = mchartRep.getConfig();


        mchart.deletePositioner();
        mchart.setHorizontal();

        mchartRep.deletePositioner();
        mchartRep.setHorizontal();


        var fn  = function(a) {
          var chart = a.target;
          var axis = chart.xAxis[0];
          var onYaxisRedraw = function() {
            for (var tickPos in axis.ticks) {
              if (axis.ticks[tickPos].label) {
                var $element = $(axis.ticks[tickPos].label.element);
                $element.unbind('click');
                $element.unbind('mouseleave');
                $element.unbind('mouseover');

                $element.css({
                  fill: "#0d47a1",
                  "font-size": "12px",
                  "text-decoration": "underline",
                  cursor: "pointer"
                });

                $element.on("click", function(a) {
                  $timeout(function() {
                    var sector = getSectorByName(a.currentTarget.textContent);
                    vm.showDialog(a, sector);
                  });
                });

              }
            }
          }
          onYaxisRedraw();
          axis.redraw(onYaxisRedraw);
        }

        chartConfig.chart.events.redraw = fn;
        chartConfigRep.chart.events.redraw = fn;


        //funcion privada
        function getSectorByName (name) {
          var ret = null;
          angular.forEach(vm.listaSectores, function(sector) {
            if (sector.nombre == name) {
              ret = sector
            }
          });
          return ret;
        }

        var params = paramsResumen;
        var dataParams = {};
        var dataLabels = {};
        var titleParms = {};

        angular.forEach(p.item.sectores, function(sector) {
          angular.forEach(params, function(param) {
            if (dataLabels[param.nameParam] == undefined) {
              dataLabels[param.nameParam] = [];
            }
            if (dataParams[param.nameParam] == undefined) {
              dataParams[param.nameParam] = [];
            }
            //para mejor navegacion de titulos
            titleParms[param.nameParam] = param.title;

            var defaultData = param.defaultData || null;
            if (sector[param.nameParam]=== null ||sector[param.nameParam]=== 0) {
              dataParams[param.nameParam].push([sector.nombre, defaultData]);
              dataLabels[param.nameParam].push(defaultData);
            }else{
              dataParams[param.nameParam].push([sector.nombre, _.round(sector[param.nameParam], 1)]);
              dataLabels[param.nameParam].push(_.round(sector[param.nameParam], 1));
            }
          });
        });






        if(p.periodoAnterior !== null){
          var itemPeriodoAnterior = p.itemPeriodoAnterior;
          var periodoAnterior = p.periodoAnterior;

          var param = { //param local en IF
            nameParam      : "porcentajeReal",
            arrayNameParam : "porcentajeRealAnterior",
            title          : "porcentaje Real",
            defaultData    : null
          };

          angular.forEach(itemPeriodoAnterior.sectores, function (sector) {
            if (dataLabels[param.arrayNameParam] === undefined) {
              dataLabels[param.arrayNameParam] = [];
            }
            if (dataParams[param.arrayNameParam] === undefined) {
              dataParams[param.arrayNameParam] = [];
            }

            //para mejor navegacion de titulos
            titleParms[param.arrayNameParam] = param.title;

            var defaultData = param.defaultData || null;
            if (sector[param.nameParam] === null || sector[param.nameParam] === 0) {
              dataParams[param.arrayNameParam].push([sector.nombre, defaultData]);
              dataLabels[param.arrayNameParam].push(defaultData);
            } else {
              dataParams[param.arrayNameParam].push([sector.nombre, _.round(sector[param.nameParam], 1)]);
              dataLabels[param.arrayNameParam].push(_.round(sector[param.nameParam], 1));
            }
          });

          var outVal = 10;

          var colorVal = [
            "#d32f2f", // red 700
            "#388e3c", // green700
            "#0d47a1"  // blue 900
          ];

          dataParams.diffRep = [];
          angular.forEach(dataParams.porcentajeReal, function (data, index) {
            var num = data[1];
            if (num === null || num === 0) {
              dataParams.diffRep.push({
                //x    : dataChart.axis[index],
                x    : index,
                low  : null,
                high : null,
              });
            }else{
              var t = 0;
              if(dataParams.porcentajeRealAnterior !== undefined &&
              dataParams.porcentajeRealAnterior[index] !== undefined){
                t = parseFloat(dataParams.porcentajeRealAnterior[index][1]);
              }

              var c = colorVal[1];
              if (Math.abs(t - parseFloat(num)) > outVal) {
                if (parseFloat(num) > t) {
                  c = colorVal[2];
                }else{
                  c = colorVal[0];
                }
              }

              dataParams.diffRep.push({
                x    : index,
                low  : parseFloat(num),//real
                high : t,//esperado
                color: c
              });
            }
          });

          mchartRep.agregarSerie({
            color       : Config.colors.riegoReal.background,
            name        : titleParms.porcentajeReal + " " + p.periodo.periodo,
            id          : "repReal",
            yAxis       : 12,
            type        : 'spline',
            lineWidth   : 0,
            //radius      : 4,
            data        : dataParams["porcentajeReal"],
            labelsData  : dataLabels["porcentajeReal"],
            markerSymbol: "diamond",
            radius      : 7,
            visibleAxis : true,
            suffix      : '%',
            error       : {
              name      : "Reposición",
              nameMin   : "Reposición Teórica",
              nameMax   : "Reposición Real",
              tooltip   : false,
              dataError : dataParams.diffRep,
            }
          });

          /*
          mchartRep.agregarSerie({
            color        : Config.colors.riegoReal.contrast,//Config.colors.riegoIdeal.background,
            name         : "2 "+titleParms.porcentajeRealAnterior + " " + periodoAnterior.periodo,
            yAxis        : 12,
            type         : 'line',
            //lineWidth    : 0,
            markerSymbol : null,
            radius       : 0,
            data         : dataParams["porcentajeRealAnterior"],
            labelsData   : dataLabels["porcentajeRealAnterior"],
            visibleAxis  : true,
            suffix       : '%',
            //legend       : false,
            linkedTo     : "repReal"
          });
          */

          //if(p.periodoAnterior !== null){ <<--- else of
        }else{
          mchartRep.agregarSerie({
            color       : Config.colors.riegoReal.background,
            name        : titleParms.porcentajeReal + " " + p.periodo.periodo,
            id          : "repReal",
            yAxis       : 12,
            type        : 'spline',
            lineWidth   : 0,
            //radius      : 4,
            data        : dataParams["porcentajeReal"],
            labelsData  : dataLabels["porcentajeReal"],
            markerSymbol: "diamond",
            radius      : 7,
            visibleAxis : true,
            suffix      : '%',
          });
        }



        var varColor = temporadaFac.getColorPeriodo(p.periodo.periodo);

        if (dataParams.riegoReal!== undefined) {
          mchart.agregarSerie({
            color       : varColor, //Config.colors.riegoReal[varColor],
            className   : 'riegoReal-'+ p.periodo.periodo,
            name        : titleParms.riegoReal +" "+ p.periodo.periodo,
            yAxis       : 2,
            type        : 'column',
            data        : dataParams.riegoReal,
            labelsData  : dataLabels.riegoReal,
            width       : 15,
            visibleAxis : true,
            suffix      : ' mm',
            labelsColor : ["#FF0000", "#0000FF", null, "#FF0000"],
            visible     : true,
          });
        }


        if (dataParams.riegoIdeal !== undefined) {
          mchart.agregarSerie({
            color       : Config.colors.riegoIdeal.background,
            className   : 'riegoIdeal-'+ p.periodo.periodo,
            name        : titleParms.riegoIdeal +" "+ p.periodo.periodo,
            yAxis       : 2,
            type        : 'column',
            data        : dataParams.riegoIdeal,
            labelsData  : dataLabels.riegoIdeal,
            width       : 15,
            visibleAxis : true,
            suffix      : ' mm',
            visible     : false,
          });
        }

        if (dataParams.volumenRealHA !== undefined) {
          mchart.agregarSerie({
            color       : varColor, //Config.colors.riegoReal[varColor], //mantiene el color de riego real
            className   : 'volumenRealHA-' + p.periodo.periodo,
            name        : titleParms.volumenRealHA +" "+ p.periodo.periodo,
            yAxis       : 7,
            type        : 'column',
            data        : dataParams.volumenRealHA,
            labelsData  : dataLabels.volumenRealHA,
            width       : 15,
            visibleAxis : true,
            suffix      : ' m3/ha',
            visible     : true,
          });
        }

        var height         = mchart.getHeight();

        return {
          mchart    : mchart,
          mchartRep : mchartRep,
          height: height
        };
      };





      /*

      //deprecated
    vm.getColor = function(nameVar, patternNumber){
      if (nameVar === undefined || Config.colors[nameVar] === undefined) {
        return "";
      }

      var color = Config.colors[nameVar].background.replace("#", "");
      var p = patternNumber || 0;
      var listPatterns = [
        //'escheresque',
        'dvsup',
        '60degree_gray',
      ]
      var pattern = listPatterns[p];

      return 'http://bg.siteorigin.com/image/generate/download?color=%23' + color +
        '&pattern=' + pattern + '&blend=4&intensity=40.00&noise=0&invert=on;'
    };


*/




    vm.dataTableResumen = {};
    /*
    vm.dataTableResumen = {
      head:["equipos", "2016-2017", "2015-2016"],
      data: [
        {
          name: "equipo 1",
          riego: [1234, 12345],
        },
        {
          name: "equipo 1",
          riego: [1234, 12345],
        },
        {
          name: "equipo 1",
          riego: [1234, 12345],
        },
        {
          name: "equipo 1",
          riego: [1234, 12345],
        }
      ]
    }
*/








    vm.chartResumen = function(res) {
      //console.log("sumando volumen - "+vm.periodoSelected.lapso);
      vm.resumen.etAcum     = 0;
      vm.resumen.reposicion = 0;
      vm.resumen.volumen    = 0;
      vm.resumen.horas      = 0;
      var i = 0;
      angular.forEach(res[vm.periodoSelected.lapso], function (lapso) {
        angular.forEach(lapso.periodos, function (periodo) {
          if (periodo.active) {
            /*vm.resumen = {
              etAcum    : periodo.etAcum,
              reposicion: periodo.porcentajeReal,
              volumen   : periodo.volumenRealHA
            }*/
            i++;
            vm.resumen.etAcum     += periodo.etAcum || 0;
            vm.resumen.reposicion += periodo.porcentajeReal || 0;
            vm.resumen.volumen    += periodo.volumenReal || 0;
            //vm.resumen.volumenHA  += periodo.volumenReal ;
            vm.resumen.horas      += periodo.horasReal || 0;
            //console.log(lapso.nombre+" sumado " + periodo.volumenReal);
          }
        });
      });
      vm.resumen.reposicion /= i;
      if (vm.periodoSelected.agrupado) {
        vm.chartResumenLapsos(res);
      } else {
        vm.chartResumenTemporada(res);
      }
      //console.log("--------- total = "+vm.resumen.volumen);
    }


    vm.chartEtMensual = function (res) {
      /*
      TODO no llamar siempre, cachear resultado
       */
      $http.get(urls.BASE + "/analisis/et-mensual?vinedo_id="+$stateParams.id)
          .then(function (res) {
            vm.chartResumenEt        = {};
            var mchartEt             = new MultiChart("Analisis mensual de Et promedio");
            vm.chartResumenEt.mchart = mchartEt;
            //mchartMax.setTableLabels();
            mchartEt.deletePositioner();
            //mchartEt.setHorizontal();

            var xaxis           = [];
            var dataEt          = {};
            var periodosActivos = {};
            var periodosList = [];


            angular.forEach(res.data.data, function (mes) {
              angular.forEach(mes.periodos, function (periodo) {//año
                if(periodosActivos[periodo.periodo] == undefined){
                  periodosActivos[periodo.periodo] = 0;
                }
                if(periodosList.indexOf(periodo.periodo) == -1){
                  periodosList.push(periodo.periodo);
                }
              });
            });

            angular.forEach(res.data.data, function (mes) {
              angular.forEach(periodosList, function (periodoOriginal) {//año
                var detectado = false;
                angular.forEach(mes.periodos, function (periodo) {//año
                  if(periodoOriginal == periodo.periodo){
                    detectado = true;
                  }
                });
                if(!detectado){
                  mes.periodos.push({
                    et      : 0,
                    periodo : periodoOriginal
                  })
                }
              });
              angular.forEach(mes.periodos, function (periodo) {//año

                if (dataEt[periodo.periodo] === undefined) {
                  dataEt[periodo.periodo] = [];
                }

                if (xaxis.indexOf(mes.nombre) === -1) {
                  xaxis.push(mes.nombre);
                }

                //item (Equipo, calidad, variedad)
                if (periodo.et === null ||periodo.et === 0) {
                  dataEt[periodo.periodo].push([mes.nombre, null]);
                  //console.log("added "+mes.nombre+" - 0");
                } else {
                  dataEt[periodo.periodo].push([mes.nombre, periodo.et ]);
                  //console.log("added "+mes.nombre+" - "+periodo.et);
                }

              });
            });


              angular.forEach(dataEt, function (dataPeriodoEt, np) {
                var varColor = temporadaFac.getColorPeriodo(np);
                mchartEt.agregarSerie({
                  //color    : Config.colors.etAcum.background,
                  color: varColor,
                  //opacity  : 50,
                  name       : 'Et promedio ' + np,
                  yAxis      : 2,
                  type       : "column",
                  //type     : 'area',
                  //step     : 'center',
                  data       : dataPeriodoEt,
                  visibleAxis: true,
                  suffix     : ' mm',
                  softMax    : false
                });
              });

            vm.chartResumenEt.config = mchartEt.getConfig();
          });

    }



              vm.chartResumenLapsos = function(res) {
                vm.chartEtMensual(res);
                vm.chartResumenMax     = {};
                vm.chartResumenPieMax  = {};
                vm.chartResumenMini    = {};
                vm.chartResumenPieMini = {};

                var mchartMax = new MultiChart("Analisis Riego Por "+vm.agrupacionSelected.nombre);
                vm.chartResumenMax.mchart = mchartMax;
                //mchartMax.setTableLabels();
                mchartMax.deletePositioner();


                var mchartPieMax = new MultiChart("Riego por "+vm.agrupacionSelected.nombre, {
                  type: "pie"
                });

                vm.chartResumenPieMax.mchart = mchartPieMax;


                var params      = paramsResumen;
                var dataParams  = {};
                var titleParms  = {};
                var sumaRiego   = {};
                var nameParam   = "riegoReal";
                var dataPie     = [];
                var xaxis       = [];
                var lapsos      = [];
                var items       = [];
                var periodos    = [];
                namesHistoricos = [];

                angular.forEach(res[vm.periodoSelected.lapso], function(lapso) { //mes
                  if(lapsos.indexOf(lapso.nombre) < 0){
                    lapsos.push(lapso.nombre);
                  }
                  angular.forEach(lapso.periodos, function(periodo) {//año
                    if (periodo.periodo === vm.temporadaSelected.periodo || vm.conHistorico ) {

                      if(periodos.indexOf(periodo.periodo) < 0){
                        periodos.push(periodo.periodo);
                      }

                      if (dataParams[periodo.periodo] == undefined) {
                        dataParams[periodo.periodo] = {};
                      }

                      if (sumaRiego[periodo.periodo] == undefined) {
                        sumaRiego[periodo.periodo] = {};
                      }

                      if (sumaRiego[periodo.periodo][lapso.nombre] == undefined) {
                        sumaRiego[periodo.periodo][lapso.nombre] = 0;
                      }

                      if (xaxis.indexOf(lapso.nombre) == -1) {
                        xaxis.push(lapso.nombre);
                      }

                      //item (Equipo, calidad, variedad)
                      angular.forEach(periodo[vm.agrupacionSelected.label], function(item) {
                        if (dataParams[periodo.periodo][item.nombre] == undefined) {
                          dataParams[periodo.periodo][item.nombre] = [];
                        }

                        if (item[nameParam] === null || item[nameParam] === 0) {
                          dataParams[periodo.periodo][item.nombre].push([lapso.nombre,null]);
                        }else{
                          dataParams[periodo.periodo][item.nombre].push([lapso.nombre, _.round(item[nameParam], 1)]);
                        }

                        sumaRiego[periodo.periodo][lapso.nombre] += item[nameParam];

                        if(items.indexOf(item.nombre) < 0){
                          items.push(item.nombre);
                        }
                      });

                    }
                  });
                });


                //verifica que todos los lapsos esten en todos los periodos,
                //y ordena si son meses
                var agregado = false;
                  angular.forEach(periodos, function(periodo) {
                    angular.forEach(items, function(item) {
                      angular.forEach(lapsos, function(lapso) { //mes
                        agregado = false;
                        angular.forEach(dataParams[periodo][item], function(itemArray) { //mes
                          if(itemArray[0] == lapso){
                            agregado = true;
                          }
                        });
                        if(!agregado){
                          if(dataParams[periodo][item] == undefined){
                            dataParams[periodo][item] =[];
                          }
                          dataParams[periodo][item].push([lapso,null]);
                        }
                      });
                      if(vm.periodoSelected.label == "meses"){
                        dataParams[periodo][item].sort(function(a,b) {
                          var m = ["junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
                                   "enero", "febrero", "marzo", "abril", "mayo"];
                          if (m.indexOf(a[0].toLowerCase()) === m.indexOf(b[0].toLowerCase())) {
                            return 0;
                          }
                          else {
                            return m.indexOf(a[0].toLowerCase()) < m.indexOf(b[0].toLowerCase()) ? -1 : 1;
                          }
                        });
                      }
                    });
                });



                angular.forEach(sumaRiego, function(periodoSuma, nombrePeriodoSuma){
                  angular.forEach(periodoSuma, function(mesSuma,nombreMesSuma){
                    if (mesSuma > 0) {
                      dataPie.push(
                        [nombreMesSuma, mesSuma]
                      );
                    }
                  });
                });


                mchartPieMax.agregarSerie({
                  color       : Config.colors.riegoReal.background,
                  name        : 'Riego Real',
                  yAxis       : 2,
                  type        : 'pie',
                  dataF       : dataPie,
                  width       : 15,
                  visibleAxis : true,
                  suffix      : ' mm'
                });


                //En resumen, solo se ve Riego en el grafico
                angular.forEach(dataParams, function(periodo, namePeriodo){
                  angular.forEach(periodo, function(itemData,nameItem){
                    mchartMax.agregarSerie({
                      //color       : Config.colors.riegoReal.background,
                      name        : nameItem+" <span class='chart-periodo'>"+namePeriodo+"</span>",
                      yAxis       : 2,
                      type        : 'column',
                      data        : angular.copy(itemData),
                      width       : 15,
                      visibleAxis : true,
                      suffix      : ' mm',
                      visible     : true,
                    });
                  });
                });
                mchartMax.setEjeX(xaxis);


                var mchartMini                = angular.copy(mchartMax);
                var mchartPieMini             = angular.copy(mchartPieMax);

                vm.chartResumenMini.mchart    = mchartMini;
                vm.chartResumenPieMini.mchart = mchartPieMini;

                mchartMini.toMini();
                mchartPieMini.toMini();

                mchartMini.setLabelFormatter(function(){ return this.value.substring(0, 3) });

                vm.chartResumenMax.config     = mchartMax.getConfig();
                vm.chartResumenPieMax.config  = mchartPieMax.getConfig();
                vm.chartResumenMini.config    = mchartMini.getConfig();
                vm.chartResumenPieMini.config = mchartPieMini.getConfig();
                vm.chartResumenMax.height     = mchartMax.getHeight();

                vm.generarTablaResumen(res);

                  $timeout(function() {
                    $scope.$broadcast('highchartsng.reflow');
                  }, 100);
              }


                vm.chartResumenTemporada = function(res) {
                  vm.chartEtMensual(res);
                  vm.chartResumenMax     = {};
                  vm.chartResumenPieMax  = {};
                  vm.chartResumenMini    = {};
                  vm.chartResumenPieMini = {};

                  var mchartMax = new MultiChart("Analisis Riego Por "+vm.agrupacionSelected.nombre);

                  //mchartMax.deleteTooltipFormatter();
                  mchartMax.deletePositioner();
                  //mchartMax.setHorizontal();

                  vm.chartResumenMax.mchart = mchartMax;
                  //mchartMax.setTableLabels();

                  var mchartPieMax = new MultiChart("Riego por Equipo", {
                    type: "pie"
                  });

                  mchartPieMax.deletePositioner();

                  vm.chartResumenPieMax.mchart = mchartPieMax;


                  var params      = paramsResumen;
                  var dataPie     = [];
                  var dataParams  = {
                    reposicion: []
                  };
                  var titleParms         = {};
                  namesHistoricos        = [];
                  var porcentajeMenor    = 0;
                  var porcentajeMayor    = 1000;
                  var posPorcentajeMenor = -1;
                  var posPorcentajeMayor = -1;

                  angular.forEach(res[vm.periodoSelected.lapso], function(lapso) {
                    angular.forEach(lapso.periodos, function(periodo) {
                      if (periodo.periodo != vm.temporadaSelected.periodo && !vm.conHistorico) {
                        return;
                      }
                      if (periodo[vm.agrupacionSelected.label] === undefined) {
                        return;
                      }
                      dataParams  = {
                        reposicion: []
                      };
                      angular.forEach(periodo[vm.agrupacionSelected.label], function(item) {
                        dataPie.push([item.nombre, item.riegoReal]);

                        angular.forEach(params, function(param) {
                          if (dataParams[param.nameParam] == undefined) {
                            dataParams[param.nameParam] = [];
                          }
                          //para mejor navegacion de titulos
                          titleParms[param.nameParam] = param.title;
                          if(periodo.periodo != vm.temporadaSelected.periodo){
                            namesHistoricos.push({
                              name    : param.title+' '+periodo.periodo,
                              param   : param.title,
                              periodo : periodo.periodo
                            });
                          }

                          var defaultData = param.defaultData || null;
                          if (item[param.nameParam]=== null || item[param.nameParam]=== 0) {
                            dataParams[param.nameParam].push([item.nombre, defaultData]);
                          }else{
                            dataParams[param.nameParam].push([item.nombre, _.round(item[param.nameParam], 1)]);
                          }

                        });

                          if (item.porcentajeReal === null || item.porcentajeReal === 0) {
                            dataParams.reposicion.push(null);
                          }else{
                            dataParams.reposicion.push(item.porcentajeReal+"%");
                            if(item.porcentajeReal > porcentajeMayor){
                              posPorcentajeMayor = dataParams.reposicion.length - 1;
                              porcentajeMayor = item.porcentajeReal;
                            }
                            if(item.porcentajeReal < porcentajeMenor){
                              posPorcentajeMenor = dataParams.reposicion.length - 1;
                              porcentajeMenor = item.porcentajeReal;
                            }
                          }


                      });



                      if (periodo.periodo == vm.temporadaSelected.periodo) {
                        //PIE
                        mchartPieMax.agregarSerie({
                          color       : Config.colors.riegoReal.background,
                          name        : 'Riego Real',
                          yAxis       : 2,
                          type        : 'pie',
                          dataF       : dataPie,
                          width       : 15,
                          visibleAxis : true,
                          suffix      : ' mm'
                        });
                      }


            var labelsColor  = [];
            var colorDefault = "#000000";
            var colorMenor   = "#FF0000";
            var colorMayor   = "#00FF00";

            for (var i = 0; i < dataParams.reposicion.length; i++) {
              if(i === posPorcentajeMenor){
                labelsColor.push(colorMenor);
              }else if(i === posPorcentajeMayor){
                labelsColor.push(colorMayor);
              }else{
                labelsColor.push(colorDefault);
              }
            }


            var varColor = temporadaFac.getColorPeriodo(periodo.periodo);

            if (dataParams.riegoReal !== undefined) {
              mchartMax.agregarSerie({
                color       : varColor, //Config.colors.riegoReal[varColor],
                className   : 'riegoReal-'+periodo.periodo,
                name        : titleParms.riegoReal +" "+ periodo.periodo,
                yAxis       : 2,
                type        : 'column',
                data        : dataParams.riegoReal,
                width       : 10,
                visibleAxis : true,
                suffix      : ' mm',
                visible     : true,
              });
            }

            if (dataParams.volumenRealHA !== undefined) {
              mchartMax.agregarSerie({
                color       : varColor, // Config.colors.riegoReal[varColor], //mantiene el color de riego real
                className   : 'volumenRealHA-'+periodo.periodo,
                name        : titleParms.volumenRealHA +" "+ periodo.periodo,
                yAxis       : 7,
                type        : 'column',
                data        : dataParams.volumenRealHA,
                width       : 10,
                visibleAxis : true,
                suffix      : ' m3/ha',
                visible     : true,
              });
            }



            if (dataParams.riegoIdeal !== undefined) {
              mchartMax.agregarSerie({
                color       : Config.colors.riegoIdeal.background,
                className   : 'riegoIdeal-'+periodo.periodo,
                name        : titleParms.riegoIdeal+" "+ periodo.periodo,
                yAxis       : 2,
                type        : 'column',
                data        : dataParams.riegoIdeal,
                width       : 10,
                visibleAxis : true,
                suffix      : ' mm',
                visible     : false,
              });
            }

            if (dataParams.produccionReal !== undefined) {
              mchartMax.agregarSerie({
                color       : Config.colors.produccionReal.background,
                className   : 'produccionReal-'+periodo.periodo,
                name        : titleParms.produccionReal+" "+ periodo.periodo,
                yAxis       : 6,
                type        : 'column',
                data        : dataParams.produccionReal,
                width       : 10,
                visibleAxis : true,
                suffix      : ' ton/ha',
                visible     : false,
                _legend     : periodo.active,
              });
            }

            if (dataParams.produccionEsperada !== undefined) {
              mchartMax.agregarSerie({
                color       : Config.colors.produccion_toneladas_ha_esperado.background,
                className   : 'produccionEsperada-'+periodo.periodo,
                name        : titleParms.produccionEsperada+" "+ periodo.periodo,
                yAxis       : 6,
                type        : 'column',
                data        : dataParams.produccionEsperada,
                width       : 10,
                visibleAxis : true,
                suffix      : ' ton/ha',
                visible     : false,
                _legend     : periodo.active,
              });
            }

            if (!vm.conHistorico) {
              mchartMax.addPlotBandY({
                color     : Config.colors.etAcumulado.background,
                border    : Config.colors.etAcumulado.background,
                className : 'etAcum-' + periodo.periodo,
                title     : "ET Acumulada " + periodo.periodo + ": " + vm.resumen.etAcum,
                yAxis     : 2,
                num       : vm.resumen.etAcum || 0,
                opacity   : 30,
              });
            }

          });
        });

        var mchartMini                = angular.copy(mchartMax);
        var mchartPieMini             = angular.copy(mchartPieMax);
        mchartMini.setHorizontal(false);

        vm.chartResumenMini.mchart    = mchartMini;
        vm.chartResumenPieMini.mchart = mchartPieMini;

        mchartMini.toMini();
        mchartPieMini.toMini();

        vm.chartResumenMax.config     = mchartMax.getConfig();
        vm.chartResumenPieMax.config  = mchartPieMax.getConfig();
        vm.chartResumenMini.config    = mchartMini.getConfig();
        vm.chartResumenPieMini.config = mchartPieMini.getConfig();
        //vm.chartResumenMax.height     = mchartMax.getHeight();
        /*
        if(vm.chartResumenMax.height > 800){
          vm.chartResumenMax.height = 800;
        }
         */

        vm.generarTablaResumen(res);

        $timeout(function() {
          $scope.$broadcast('highchartsng.reflow');
        }, 100);
      }


    vm.generarTablaResumen = function(res){
      if (vm.conHistorico) {
        var head = [];
        var dataTable = {};

        angular.forEach(res[vm.periodoSelected.lapso], function(lapso) { //mes
          angular.forEach(lapso.periodos, function(periodo) {//año
            if (head.indexOf(periodo.periodo) == -1 && periodo[vm.agrupacionSelected.label] !== undefined) {
              head.push(periodo.periodo);
            }
            angular.forEach(periodo[vm.agrupacionSelected.label], function(item) {
              if (dataTable[item.nombre] === undefined) {
                dataTable[item.nombre] = {};
              }
              if(dataTable[item.nombre][periodo.periodo] == undefined){
                dataTable[item.nombre][periodo.periodo] = 0;
              }
              dataTable[item.nombre][periodo.periodo] += item.volumenRealHA;
            });
          });
        });

        head.sort();

        vm.dataTableResumen.head = head;
        var dataTableResumenFormated = [];

        angular.forEach(dataTable, function(periodos,nameEquipo){
          var dataPeriodo = [];
          var dataArrayPeriodo = [];
          angular.forEach(periodos, function(data, periodo){
            //dataPeriodo.push(data);
            dataArrayPeriodo.push([periodo, data]);
          });
          dataArrayPeriodo.sort(function(a,b) {
            if (a[0] === b[0]) {
              return 0;
            }
            else {
              return (a[0] < b[0]) ? -1 : 1;
            }
          });
          angular.forEach(dataArrayPeriodo, function(item){
            dataPeriodo.push(item[1]);
          });
          dataTableResumenFormated.push({
            name: nameEquipo,
            checked: true,
            riego:dataPeriodo
          });
        });

        vm.dataTableResumen.data = dataTableResumenFormated;
      }
    }





    function getItemPeriodoAnterior (res, paramPeriodo, paramItem, agrupadoPor) {
      var rItem = null;
      var rPeriodo = null;
      angular.forEach(res[vm.periodoSelected.lapso], function(lapso) {
        angular.forEach(lapso.periodos, function(periodo, indexP) {
          if (paramPeriodo == periodo && lapso.periodos[indexP - 1] !== undefined) {
            var periodoAnterior = lapso.periodos[indexP-1];
            angular.forEach(periodoAnterior[agrupadoPor], function(item) {
              if (item.id == undefined && item.ids !== undefined) {
                item.id = item.ids[0];
              }
              if (paramItem.id == item.id) {
                rItem = item;
                rPeriodo = periodoAnterior;
              }
            });
          }
        });
      });
      return {
        item: rItem,
        periodo: rPeriodo
      };
    }




    vm.graficar = function(res) {

      vm.charts        = [];
      vm.listaSectores = [];
      vm.lapsos        = {};
      vm.grupos        = {};
      vm.gruposArray   = {};
      vm.grupoSelected = null;
      //vm.allCharts     = true; //loading
      //var dataChart    = {};
      var data         = angular.copy(dataHttp); //datos para peticion
      data.periodo     = vm.temporadaSelected.periodo;
      //var prom         = estadisticaFac.getVinedoIdeal(data).$promise;
      var agrupadoPor  = vm.agrupacionSelected.label; //XXX "equipo, variedad, calidad"




      //prom.then(function(res) {
        //res = resAnalisis; //TODO temporal, volver real
        angular.forEach(res[vm.periodoSelected.lapso], function(lapso) {

          var lapsoObj = {
            nombre: lapso.nombre,
            charts : []
          };

          if (_.isEmpty(vm.lapsos)) {
            vm.lapsoSelected = lapsoObj;
          }
          if (lapso.nombre === undefined) {
            lapso.nombre = vm.periodoSelected.lapso;
          }

          vm.lapsos[lapso.nombre] = lapsoObj;


          angular.forEach(lapso.periodos, function(periodo, indexP) {
            angular.forEach(periodo[agrupadoPor], function(item) {
              if (vm.grupos[item.nombre] === undefined) {
                vm.grupos[item.nombre] = [];
              }
              if (periodo.periodo == vm.temporadaSelected.periodo || vm.conHistorico) {
                if (item.sectores.length > 0) {
                  //situacion que se da con las calidades
                  if (item.id == undefined && item.ids !== undefined) {
                    item.id = item.ids[0];
                  }
                  //un item es un grupo de sectores, con datos propios igual
                  //puede ser un equipo, una variedad, una calidad o el viñedo completo
                  var c        = getChartByIdItem(lapsoObj.charts, item.id);
                  var title    = "Análisis de riego para " + item.nombre;
                  var titleRep = "Análisis de reposición para " + item.nombre;

                  var objPeriodoAnterior = {
                    item: null,
                    periodo: null
                  }
                  if (periodo.active) {
                    objPeriodoAnterior = getItemPeriodoAnterior(res, periodo, item, agrupadoPor);
                  }

                  if (c !== null) {
                    var mchartObj = vm.getMChart({
                      title              : title,
                      titleRep           : titleRep,
                      item               : item,
                      periodo            : periodo,
                      itemPeriodoAnterior: objPeriodoAnterior.item,
                      periodoAnterior    : objPeriodoAnterior.periodo,
                      mchartObj          : c.mchartObj //referencia
                    });
                    c.chartConfig    = c.mchart.getConfig();
                    c.chartConfigRep = c.mchartRep.getConfig();
                    c.height         = mchartObj.height;
                  }else{
                    var m = moment.duration(item.horasReal, "hours");
                    var h = Math.floor(m.asHours()) +":"+ (m.minutes() < 10 ? '0':'')+m.minutes();

                    var chartItem                    = {};
                    chartItem.mchartObj              = vm.getMChart({
                                                          title              : title,
                                                          titleRep           : titleRep,
                                                          item               : item,
                                                          periodo            : periodo,
                                                          itemPeriodoAnterior: objPeriodoAnterior.item,
                                                          periodoAnterior    : objPeriodoAnterior.periodo,
                                                        });
                    chartItem.mchart                 = chartItem.mchartObj.mchart;
                    chartItem.height                 = chartItem.mchartObj.height;
                    chartItem.mchartRep              = chartItem.mchartObj.mchartRep;
                    chartItem.chartConfig            = chartItem.mchart.getConfig();
                    chartItem.chartConfigRep         = chartItem.mchartRep.getConfig();
                    chartItem.item                   = item;
                    chartItem.item.horasRealFormated = h;
                    chartItem.loadingChart           = false;

                    vm.charts.push(chartItem);
                    lapsoObj.charts.push(chartItem);
                    vm.grupos[item.nombre].push(chartItem);
                  }
                }
              }
            });
          });

          //para poder recorrer los grupos como array, en el selector
          //de la vista
          vm.gruposArray = [];
          angular.forEach(vm.grupos, function(grupo, index){
            vm.gruposArray.push({
              charts : grupo,
              nombre: index
            });
          });
        });

        vm.grupoSelected = vm.gruposArray[0];

        if (!vm.periodoSelected.agrupado) {
          vm.grupoSelected = vm.lapsos[vm.periodoSelected.lapso];
        }

        //vm.itemSelected = vm.charts[0].item;
      //});
    }





    var getChartByIdItem = function (charts,id) {
      var c = null;
      angular.forEach(charts, function (chart) {
        if (chart.item.id == id) {
          c = chart;
        }
      });
      return c;
    }




    vm.changeComparisonType = function(type) {
      vm.comparisonTypeSelected = type;
      vm.reload();
    }

    vm.selectPeriodo = function(periodo) {
      vm.periodoSelected = periodo;
      vm.reload();
    }





    vm.selectAgrupacion = function(agrupacion) {
      vm.reload();
    }








    function getPeriodo(nombre) {
      var p = null;
      angular.forEach(vm.periodos, function(periodo) {
        if (periodo.nombre == nombre) {
          p = periodo;
        }
      });
      return p;
    }










      /**
      * @ngdoc method
      * @name irricrops.vinedoComparacionCtrl#verificarRuta
      * @methodOf irricrops.vinedoComparacionCtrl
      *
      * @description
      * verifica las variables de la ruta y redirecciona a la funcion llamada
      * si no hay variables, llama a la funcion selectPeriodo() con el periodo
      * de temporada com parametro
      *
      * variables:
      *   - mes
      *   - inicio y termino
      *   - estado
      **/
       function verificarRuta_ () {
        var invalidRoute = true;
         if($stateParams.mes){
           var mesSelected = null;
           angular.forEach(vm.meses, function(mes) {
             if(mes.numero == $stateParams.mes){
               mesSelected = mes;
             }
           });
           if (mesSelected !== null) {
             invalidRoute = false;
             vm.mesSelected = mesSelected;
             vm.selectPeriodo(getPeriodo("Meses"));
           }


         }else if($stateParams.inicio && $stateParams.termino){
           var mi = moment($stateParams.inicio, "DD-MM-YYYY");
           var mt = moment($stateParams.termino, "DD-MM-YYYY");
           if (mi.isValid() && mt.isValid() && mi.isBefore(mt)) {
             invalidRoute = false;
             vm.inicio = mi.toDate();
             vm.termino = mt.toDate();
             vm.selectPeriodo(getPeriodo("Entre Fechas"));
           }


         }else if($stateParams.estado){
           var estadoSelected = null;
           angular.forEach(vm.estados, function(estado) {
             if (estado.nombre == $stateParams.estado) {
               estadoSelected = estado;
             }
           });
           if (estadoSelected || (vm.listMode && $stateParams.estado == 1)) {
             invalidRoute = false;
             vm.estadoSelected = estadoSelected;
             vm.selectPeriodo(getPeriodo("Estado Fenologico"));
           }
         }else if($stateParams.comparacion){
           invalidRoute = false;
           vm.selectComparacion();
           vm.selectComparacionVariedad();
          vm.selectPeriodo(getPeriodo("Comparación"));
         }else if($stateParams.temporada){
           invalidRoute = false;
           vm.selectPeriodo(getPeriodo("Temporada"));
         }


         if(invalidRoute){
           if (vm.resumen === undefined) {
            vm.selectPeriodo(getPeriodo("Temporada"));
           }else{
            vm.selectPeriodo(getPeriodo("Resumen"));
           }
         }
       }










       /*****
        *  Inicio de graficos
        */

       vm.init = function() {
         //var data          = angular.copy(dataHttp);
         //data.periodo      = vm.temporadaSelected.periodo;
         //var promEstados   = estadisticaFac["getEstadosVinedo"](data).$promise;
         //var promMeses     = estadisticaFac["getMesesVinedo"](data).$promise;
        vm.reload();
       };







      temporadaFac.getTemporadas().then(function(res) {
        vm.temporadas = res.data.data;
        vm.temporadaSelected = temporadaFac.getActiva();
        vm.init();
      });






      vm.cambiarTemporada = function(temporada) {
        vm.reload();
      };






       vm.showDialog = function(ev, sector) {
         cuartelDialog.showDialog(ev, sector.id);
       };

      vm.toggleHistorico = function () {
        vm.reload();
      };


      vm.changeFechas= function () {
        vm.reload();
      };

      vm.refreshListaSectores = function(res){
        angular.forEach(res[vm.periodoSelected.lapso], function(lapso){
          angular.forEach(lapso.periodos, function(periodo){

            if (periodo.active) {
              angular.forEach(periodo[vm.agrupacionSelected.label], function(equipo){
                angular.forEach(equipo.sectores, function(sector){

                  var objSector ={
                    id: sector.id,
                    nombre: sector.nombre
                  }
                  if(vm.listaSectores.indexOf(objSector) == -1){
                    vm.listaSectores.push(objSector);
                  }

                });
              });
            }

          });
        });
      }



        vm.reload = function(){
          vm.allCharts = true;
          var params= {
            vinedo_id: $stateParams.id, //sacando la id de la ruta
          };
          var url = "";
          params[vm.agrupacionSelected.label] = true;
          switch (vm.periodoSelected.label) {
            case 'temporada':
              if(vm.comparisonTypeSelected == vm.COMP_TEMPORADA ){
                url = urls.BASE+"/analisis/analisis-temporada";
              }
              else if(vm.comparisonTypeSelected == vm.COMP_DATE){
                url = urls.BASE+"/analisis/analisis-fechas";
                var dateInicio = moment(vm.temporadaSelected.inicio).toDate();
                params.fecha_inicio = dateInicio;
                params.fecha_fin = new Date();
              }
              break;
            case 'meses':
              url = urls.BASE+"/analisis/analisis-meses";
              break;
            case 'fechas':
              url = urls.BASE+"/analisis/analisis-fechas";
              params.fecha_inicio = vm.inicio;
              params.fecha_fin = vm.termino;
              break;
            case 'estados':
              url = urls.BASE+"/analisis/analisis-estados"; // pendiente
              break;
            default:
              url = urls.BASE+"/analisis/analisis-temporada";
          }

          //ruta solo para temporada
          $http.get(url, {params:params})
            .then(function(res) {

              var sectoresXLS = [];
              var archive = [];

              _.each(res.data.data.temporada[0].periodos, function(periodo){
                _.each(periodo, function(){
                  if(periodo.conDatos){
                    _.each(periodo.variedades, function(variedad){
                      _.each(variedad.sectores, function(sector){
                        if(archive[periodo.periodo] === undefined){
                          archive[periodo.periodo] = [];
                        }
                        if(archive[periodo.periodo].indexOf(sector.id) === -1){
                          sectoresXLS.push({
                            periodo         : periodo.periodo,
                            equipo          : sector.equipo,
                            sector          : sector.nombre,
                            hectareas       : _.round(sector.ha, 2),
                            variedad        : variedad.nombre,
                            volumen_real : _.round(sector.volumenRealHA, 2),
                            volumen_real_ha    : _.round(sector.volumenReal, 2),
                            horas_total     : sector.horasReal,
                            mm_total        : sector.riegoReal
                          });
                          archive[periodo.periodo].push(sector.id);
                        }
                      });
                    });
                  }
                });
              });

              console.dir(sectoresXLS);





              //$timeout(function(){
                vm.graficar(res.data.data);
                vm.chartResumen(res.data.data);
                vm.refreshListaSectores(res.data.data);
                vm.allCharts = false;
              //}, 1000);
            });
        }












     }]);

   })();
